import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  select(event) {
    const name = event.currentTarget.dataset.name
    const input = document.querySelector("input[name='collection_name']")
    if (input) {
      input.value = name
    }
  }
}
